/**
 * @generated SignedSource<<f4acbf8ee105ff82e72ad134af3ee67d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type realtimeUpdaterOld_nativeIssueTable_issues$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
    readonly node: {
      readonly issueId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly jql: string | null | undefined;
  readonly " $fragmentType": "realtimeUpdaterOld_nativeIssueTable_issues";
};
export type realtimeUpdaterOld_nativeIssueTable_issues$key = {
  readonly " $data"?: realtimeUpdaterOld_nativeIssueTable_issues$data;
  readonly " $fragmentSpreads": FragmentRefs<"realtimeUpdaterOld_nativeIssueTable_issues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "realtimeUpdaterOld_nativeIssueTable_issues",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "issueId"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "a8f2d8f1da1dde631a84b116ef724aa6";

export default node;
